import { translate } from "app/filters/i18nFilter";
import type { SuggestionQuickAction } from "app/pages/sales-intelligence/modules/suggestions/types";
import { SuggestionQuickActionType } from "app/pages/sales-intelligence/modules/suggestions/types/enums";

export const getSuggestionsQuickActions = (): Record<string, SuggestionQuickAction> => ({
    [SuggestionQuickActionType.FindProspects]: {
        title: translate("si.suggestion.find_prospects.title"),
        description: translate("si.suggestion.find_prospects.description"),
        iconName: "search-gradient",
        type: SuggestionQuickActionType.FindProspects,
        dataAutomation: SuggestionQuickActionType.FindProspects,
    },
    [SuggestionQuickActionType.CraftEmail]: {
        title: translate("si.suggestion.craft_email.title"),
        description: translate("si.suggestion.craft_email.description"),
        iconName: "craft-email-gradient",
        type: SuggestionQuickActionType.CraftEmail,
        dataAutomation: SuggestionQuickActionType.CraftEmail,
    },
    [SuggestionQuickActionType.PrepareForMeeting]: {
        title: translate("si.suggestion.prepare_meeting.title"),
        description: translate("si.suggestion.prepare_meeting.description"),
        iconName: "ai-calendar-gradient",
        type: SuggestionQuickActionType.PrepareForMeeting,
        dataAutomation: SuggestionQuickActionType.PrepareForMeeting,
    },
    [SuggestionQuickActionType.EnrichCompanies]: {
        title: translate("si.suggestion.enrich_companies.title"),
        description: translate("si.suggestion.enrich_companies.description"),
        iconName: "enrichment-gradient",
        type: SuggestionQuickActionType.EnrichCompanies,
        dataAutomation: SuggestionQuickActionType.EnrichCompanies,
    },
    [SuggestionQuickActionType.CreateList]: {
        title: translate("si.suggestion.build_list.title"),
        description: translate("si.suggestion.build_list.description"),
        iconName: "list-gradient",
        type: SuggestionQuickActionType.CreateList,
        dataAutomation: SuggestionQuickActionType.CreateList,
    },
    [SuggestionQuickActionType.ScoringCriteria]: {
        title: translate("si.suggestion.scoring_criteria.title"),
        description: translate("si.suggestion.scoring_criteria.description"),
        iconName: "alerts",
        type: SuggestionQuickActionType.ScoringCriteria,
        dataAutomation: SuggestionQuickActionType.ScoringCriteria,
        isNew: true,
    },
});

export const SUGGESTIONS_QUICK_ACTIONS_ORDER: Record<string, number> = {
    [SuggestionQuickActionType.ScoringCriteria]: 0,
    [SuggestionQuickActionType.FindProspects]: 1,
    [SuggestionQuickActionType.CraftEmail]: 2,
    [SuggestionQuickActionType.PrepareForMeeting]: 3,
    [SuggestionQuickActionType.EnrichCompanies]: 5,
    [SuggestionQuickActionType.CreateList]: 4,
};
